var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:_vm.classes},[(_vm.userInfo.avatar)?[_c('img',{attrs:{"alt":_vm._f("fullname")(_vm.userInfo),"src":_vm.userInfo.avatar}})]:(_vm.userInfo.name && _vm.userInfo.name.length > 0)?[_vm._v(_vm._s(_vm._f("initials")(_vm.userInfo)))]:[_c('SvgIcon',{attrs:{"icon":"user_default"}})],_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }